import { amountText } from '../../models/units'

export const IngredientAmount = ({
  entry,
  amount,
  amountMax,
  unit,
  className
}) => {
  const useAmount = entry ? entry.amount : amount
  const useMax = entry ? entry.amountMax : amountMax
  const useUnit = entry ? entry.unit : unit

  return (
    <span className={className} key={useUnit}>
      {` ${amountText(useAmount, useUnit, useMax)}`}
    </span>
  )
}
